module.exports = __webpack_public_path__ + "img/survey.946f5091.svg";